import {
  Autocomplete,
  Box,
  Button,
  CircularProgress,
  Grid,
  Paper,
  Stack,
  Tab,
  Tabs,
  TextField,
  TextFieldProps,
  Typography,
} from "@mui/material";
import { LocalizationProvider, TimePicker } from "@mui/x-date-pickers";
import React from "react";
import {
  Controller,
  FormProvider,
  useForm,
  useFormContext,
} from "react-hook-form";
import {
  RHFAutocomplete,
  RHFCheck,
  RHFDate,
  RHFText,
  RHFTime,
  SectionTitle,
  TabPanel,
} from "./AppointmentListDetail";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs, { Dayjs } from "dayjs";
import {
  anaggpPacada,
  calProgPacada,
  datiPacadc,
  doctor,
  generalResearch,
  ricAnapres,
  ricGPDistr,
  ricGPMetod,
  ricGPQudia,
  ricpgmedt,
} from "../../../networking";
import { Helmet } from "react-helmet-async";
import { AllertMessage } from "../../DoctorsList/Medint/MedintDetails/MedintDetails";

export interface Pacadc {
  idPacadc: string;
  crud: "R" | "U" | "D"; // Read / Update / Delete

  PACADCSWTEMP: string;
  PACADCSWPRIMARIO: string;
  CODMEDINT: string;
  DATAVISITA: string;
  ORAVISITA: string;
  DURATA: string;
  CODSPECIA: string;
  CODANAPRE: string;
  CODTPGPRE: string;
  CODCLSPRT: string;
  CODIDTPRE: string;
  CODTPRICE: string;
  IMPEGNATIVA: string;
  DATAIMPEGNATIVA: string;
  DATA1DISP: string;
  IUP: string;
  CODESENZ: string;
  CODTIPRAM: string;
  CODPGMEDT: string;
  COMPETENZA: string;
  DIAGNOSI: string;
  NOTE: string;
  SWFORZATURA: string;
  SWUSUFRUITO: string;
  SWARRIVATO: string;
  DATAARRIVO: string;
  ORAARRIVO: string;
  SWASSENZA: string;
  MEDSOSTITUITO: string;
  MEDRELAZIONATO: string;
  IDACCETTAZIONE: string;
  PRESCRSUGGERITA: string;
  FLAGALTRO: string;
  FLAGPIC: string;
  IDPAI: string;
  PROTOCOLLOPIC: string;
  TOLLGGATTESA: string;
  APPROFONDIMENTO: string;
  PRIMOACCESSO: string;
  IURP: string;
  CODANAPRES: string;
  IDAPPGP: string;
  CODANAGGP: string;
  IDPROGCOMBINATO: string;
  CODISTCOM: string;
  CODGPMETOD: string;
  CODGPQUDIA: string;
  CODGPDISTR: string;
  CODNOMENCLREG: string;
  CODCATALOGOPRESCR: string;
  PRESCRITTORE: string;
  CODOPERATORE: string;
  DATAANNULLAMENTO: string;
  ORAANNULLAMENTO: string;
  CODOPEANNULLAMENTO: string;
  IDOPANNULLAMENTO: string;
  SWSOSPESO: string;
  SWDAPAGARE: string;
  aziendaPrenotazione: string;
}

type AppointmentListDetailProps = {
  onClose: () => void;
  dataAppuntamento: any;
  azienda: string | undefined;
  prenotazioneRequest: (
    numeroPrenotazione: string,
    aziendaPrenotazione: string
  ) => Promise<void>;
};

type FormValuesPacadc = {
  // top
  dataPrenotazione: Dayjs | null; // ??? CODIDTPRE ???
  numeroPrenotazione: string; // ???
  paziente: string; // ???
  medico: string; // ? CODMEDINT ?

  dataVisita: Dayjs | null; // DATAVISITA
  oraVisita: Dayjs | null; // ORAVISITA
  durata: string; // DURATA

  // status flags
  usufruito: boolean; // SWUSUFRUITO
  inArrivo: boolean; // ???
  arrivato: boolean; // SWARRIVATO

  dataArrivo: Dayjs | null; // DATAARRIVO
  oraArrivo: Dayjs | null; // ORAARRIVO

  competenza: string; // COMPETENZA
  tipologia: string; // ? CODTPGPRE ?

  impegnativa: string; // IMPEGNATIVA
  iup: string; // IUP

  primoAccesso: boolean; // PRIMOACCESSO
  daPagare: boolean; // PRIMOACCESSO

  diagnosi: string; // DIAGNOSI
  notePrestazione: string; // ? NOTE ?

  idTipoPrestazione: string; // ? CODTPGPRE ?
  medicoRelaz: string; // MEDRELAZIONATO
  medicoSostituto: string; // MEDSOSTITUITO
  temporaneo: boolean; // PACADASWTEMP

  dataAnnullamento: Dayjs | null;
  oraAnnullamento: Dayjs | null;
  codiceOperatoreAnnullamento: string;
  sospeso: boolean;
  idOperatoreAnnullamento: string;

  //Dati GP
  idAppuntamento?: string; // IDAPPGP
  idCombinato?: string; // IDPROGCOMBINATO
  codiceIURP?: string; // IURP
  prestazioneSISS?: string; // CODCATALOGOPRESCR / (se diverso, mappalo)
  codAgenda?: string; // CODANAGGP
  idCombinata?: string; // CODISTCOM
  quadroDiagnostico?: string; // CODGPQUDIA
  metodica?: string; // CODGPMETOD
  distretto?: string; // CODGPDISTR (o CODISTCOM se diverso)
  esenzione?: string; // CODESENZ
  prescrittore?: string; // PRESCRITTORE
  provenienza?: string; // CODNOMENCLREG (se inteso come provenienza, altrimenti mappa corretta)
  tipoRicetta?: string; // CODTPRICE
  programma?: string; // CODGPDISTR / altro codice programma
  nomenclatoreReg?: string; // CODNOMENCLREG
  catalogoPrescr?: string; // CODCATALOGOPRESCR
};

type Option = { label: string; value: string };

const RHFTimePacadc = ({
  name,
  label,
}: {
  name: keyof FormValuesPacadc;
  label?: string;
}) => {
  const { control } = useFormContext<FormValuesPacadc>();
  return (
    <Controller
      name={name as any}
      control={control}
      render={({ field }) => (
        <TimePicker
          label={label}
          value={field.value as Dayjs | null}
          format={"HH:mm"}
          ampm={false}
          onChange={field.onChange}
          slotProps={{
            textField: { size: "small", fullWidth: true, placeholder: "01:00" },
          }}
        />
      )}
    />
  );
};

const RHFDatePacadc = ({
  name,
  label,
}: {
  name: keyof FormValuesPacadc;
  label?: string;
}) => {
  const { control } = useFormContext<FormValuesPacadc>();
  return (
    <Controller
      name={name as any}
      control={control}
      render={({ field }) => {
        const value = dayjs(field.value).isValid()
          ? dayjs(field.value).format("YYYY-MM-DD")
          : "";

        return (
          <TextField
            label={label}
            type="date"
            value={value}
            onChange={(e) =>
              field.onChange(e.target.value ? dayjs(e.target.value) : null)
            }
            fullWidth
            size="small"
            InputLabelProps={{ shrink: true }}
          />
        );
      }}
    />
  );
};

const RHFTextPacadc = (
  props: TextFieldProps & { name: keyof FormValuesPacadc }
) => {
  const {
    register,
    formState: { errors },
  } = useFormContext<FormValuesPacadc>();
  const err = errors[props.name]?.message as string | undefined;
  return (
    <TextField
      fullWidth
      size="small"
      placeholder="Placeholder"
      {...props}
      {...register(props.name)}
      error={!!err}
      helperText={err}
    />
  );
};

export default function AppointmentDeletedListDetail({
  onClose,
  dataAppuntamento,
  azienda,
  prenotazioneRequest,
}: AppointmentListDetailProps) {
  const [tab, setTab] = React.useState(0);

  // Allert di conferma/risultato
  const [showAllert, setShowAllert] = React.useState(false);
  const [severity, setSeverity] = React.useState<
    "warning" | "success" | "error"
  >("warning");
  const [message, setMessage] = React.useState("");

  // Chiedo conferma prima di inviare la modifica
  const askConfirmEditAppuntamento = () => {
    setMessage("Confermare l'aggiornamento dell'appuntamento?");
    setSeverity("warning");
    setShowAllert(true);
  };

  // Eseguo l’update quando l’utente conferma nell’alert
  const onAlertConfirm = async () => {
    try {
      await sendAppointmentDetailsUpdate();
    } catch (err) {
      console.error(err);
      setSeverity("error");
      setMessage("Si è verificato un errore durante la modifica.");
    }
  };

  // L'alert si chiude dopo 4 secondi se non è di tipo warning
  React.useEffect(() => {
    if (showAllert && severity !== "warning") {
      const t1 = setTimeout(() => setShowAllert(false), 4000);
      const t2 = setTimeout(() => {
        setSeverity("warning");
        setMessage("");
      }, 6000);
      return () => {
        clearTimeout(t1);
        clearTimeout(t2);
      };
    }
  }, [showAllert, severity]);

  const fmtDate = (d: any, fallback = "1901-01-01") => {
    const v = dayjs(d);
    return v.isValid() ? v.format("YYYY-MM-DD") : fallback;
  };

  const fmtTime = (t: any, fallback = "0") => {
    // TimePicker ti passa un Dayjs o null
    if (dayjs.isDayjs(t) && t.isValid()) return t.format("HHmm");
    // se arrivasse una stringa tipo "1730" o "17:30"
    const s = typeof t === "string" ? t.trim() : "";
    if (s) {
      const tryA = dayjs(s, "HH:mm", true);
      if (tryA.isValid()) return tryA.format("HHmm");
      const tryB = dayjs(s, "HHmm", true);
      if (tryB.isValid()) return tryB.format("HHmm");
    }
    return fallback;
  };

  const defaultValues: FormValuesPacadc = {
    dataPrenotazione: dayjs(dataAppuntamento.DATAPRENOTAZIONE),
    numeroPrenotazione: dataAppuntamento.NUMPRENOTAZIONE,
    paziente: dataAppuntamento.NOMINPAZIENTE,
    medico: dataAppuntamento.CODMEDINT ?? "", //

    dataVisita: dayjs(dataAppuntamento.DATAVISITA), //
    oraVisita: dayjs(dataAppuntamento.ORAVISITA.padStart(4, "0"), "HHmm"), //
    durata: dataAppuntamento.DURATA, //

    usufruito: dataAppuntamento.SWUSUFRUITO === "" ? false : true,
    inArrivo: dataAppuntamento.SWARRIVATO === "N" ? true : false,
    arrivato: dataAppuntamento.SWARRIVATO === "N" ? false : true,

    dataArrivo: dayjs(dataAppuntamento.DATAARRIVO),
    oraArrivo: dayjs(dataAppuntamento.ORAARRIVO.padStart(4, "0"), "HHmm"),

    competenza: dataAppuntamento.COMPETENZA,
    tipologia: dataAppuntamento.CODTPGPRE,

    impegnativa:
      dataAppuntamento.IMPEGNATIVA === ""
        ? ""
        : dataAppuntamento.IMPEGNATIVA,
    iup: dataAppuntamento.IUP === "" ? "" : dataAppuntamento.IUP,

    primoAccesso: dataAppuntamento.PRIMOACCESSO === "" ? false : true,
    daPagare: false,

    diagnosi: dataAppuntamento.DIAGNOSI,
    notePrestazione: dataAppuntamento.NOTE,

    idTipoPrestazione: dataAppuntamento.CODIDTPRE ?? "",
    medicoRelaz: dataAppuntamento.NOMINMEDICOREL ?? "",
    medicoSostituto: dataAppuntamento.NOMINMEDICOSOST ?? "",
    temporaneo: dataAppuntamento.PACADASWTEMP === "T" ? true : false,

    // Dati Annullamento
    dataAnnullamento: dayjs(dataAppuntamento.DATAANNULLAMENTO),
    oraAnnullamento: dayjs(
      dataAppuntamento.ORAANNULLAMENTO.padStart(4, "0"),
      "HHmm"
    ),
    codiceOperatoreAnnullamento: dataAppuntamento.CODOPEANNULLAMENTO ?? "",
    sospeso: dataAppuntamento.SWSOSPESO === "1" ? true : false,
    idOperatoreAnnullamento: dataAppuntamento.IDOPANNULLAMENTO,

    // Dati GP
    idAppuntamento: String(dataAppuntamento.IDAPPGP || ""),
    idCombinato: String(dataAppuntamento.IDPROGCOMBINATO || ""),
    codiceIURP: String(dataAppuntamento.IURP || ""),
    prestazioneSISS: String(dataAppuntamento.CODANAPRES || ""),
    codAgenda: String(dataAppuntamento.CODANAGGP || ""),
    idCombinata: String(dataAppuntamento.CODISTCOM || ""),
    quadroDiagnostico: String(dataAppuntamento.CODGPQUDIA || ""),
    metodica: String(dataAppuntamento.CODGPMETOD || ""),
    distretto: String(dataAppuntamento.CODGPDISTR || ""),
    esenzione: String(dataAppuntamento.CODESENZ || ""),
    prescrittore: String(dataAppuntamento.PRESCRITTORE || ""),
    provenienza: String(dataAppuntamento.CODTIPRAM || ""),
    tipoRicetta: String(dataAppuntamento.CODTPRICE || ""),
    programma: String(dataAppuntamento.CODPGMEDT || ""),
    nomenclatoreReg: String(dataAppuntamento.CODNOMENCLREG || ""),
    catalogoPrescr: String(dataAppuntamento.CODCATALOGOPRESCR || ""),
  };

  // Stato options Medici: pre-popolato col medico corrente
  const [mediciOpts, setMediciOpts] = React.useState<Option[]>(() => {
    const code = String(dataAppuntamento.CODMEDINT || "");
    const name = dataAppuntamento.NOMINMEDICO || "";
    return code
      ? [{ value: code, label: name ? `${code} - ${name}` : code }]
      : [];
  });

  const mapDoctor = (d: any): Option => ({
    value: String(d.CODICE),
    label: d.DESCRIZIONE ? `${d.CODICE} - ${d.DESCRIZIONE}` : String(d.CODICE),
  });

  React.useEffect(() => {
    //Variabile per evitare di fare setState durante l'unmount del componente
    let active = true;
    (async () => {
      try {
        const res = await doctor({
          tipoAgenda: "",
          listino: "",
          specialita: "",
          prestazione: "",
          medico: "",
        });

        const list = (res?.data?.dati ?? []).map(mapDoctor);

        // aggiungo il medico corrente se non è presente
        const currentCode = String(dataAppuntamento.CODMEDINT || "");
        const currentLabel =
          dataAppuntamento.NOMINMEDICO ||
          list.find((l: Option) => l.value === currentCode)?.label ||
          currentCode;

        // Metto il medico attuale in testa e il resto della lista, eliminando doppioni
        const merged = currentCode
          ? [{ value: currentCode, label: currentLabel }, ...list].filter(
              (opt, i, arr) => arr.findIndex((o) => o.value === opt.value) === i
            )
          : list;

        if (active) setMediciOpts(merged);
      } catch (e) {
        console.error("Doctor fetch error:", e);
      }
    })();
    return () => {
      active = false;
    };
  }, []);

  const methods = useForm<FormValuesPacadc>({ defaultValues });

  // Mappa un record dell’API in Option
  // Accetta sia {CODICE, DESCRIZIONE} che {codice, descrizione}.
  const mapApiItemToOption = (r: any): Option => {
    const code = String(r.CODICE ?? r.codice ?? r.pkey ?? "");
    const desc = r.DESCRIZIONE ?? r.descrizione ?? "";
    return {
      value: code,
      label: desc ? `${code} - ${desc}` : code,
    };
  };

  // Carica le opzioni via generalResearch
  // --- in alto al file (fuori dal componente) ---
  const __optsCache = new Map<string, Option[]>();

  const useResearchOptions = (
    tabella: "ISTCOM" | "ESENZ" | "TIPRAM" | "TPRICE",
    initialOption?: Option,
    customLoader?: () => Promise<Option[]>, // NEW: loader alternativo
    cacheKey?: string // NEW: chiave cache
  ) => {
    const key = cacheKey || tabella;

    const [options, setOptions] = React.useState<Option[]>(
      initialOption ? [initialOption] : []
    );
    const [loading, setLoading] = React.useState(false);
    const [loadedOnce, setLoadedOnce] = React.useState<boolean>(() =>
      __optsCache.has(key)
    );
    const abortRef = React.useRef<AbortController | null>(null);

    React.useEffect(() => {
      if (__optsCache.has(key)) {
        const cached = __optsCache.get(key)!;
        setOptions(
          initialOption
            ? [initialOption, ...cached].filter(
                (o, i, a) => a.findIndex((x) => x.value === o.value) === i
              )
            : cached
        );
        setLoadedOnce(true);
      } else {
        setOptions(initialOption ? [initialOption] : []);
        setLoadedOnce(false);
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [key]);

    const load = React.useCallback(async () => {
      if (loadedOnce) return;
      if (__optsCache.has(key)) {
        const cached = __optsCache.get(key)!;
        setOptions(
          initialOption
            ? [initialOption, ...cached].filter(
                (o, i, a) => a.findIndex((x) => x.value === o.value) === i
              )
            : cached
        );
        setLoadedOnce(true);
        return;
      }

      setLoading(true);
      abortRef.current?.abort();
      const ac = new AbortController();
      abortRef.current = ac;

      try {
        let list: Option[];
        if (customLoader) {
          list = await customLoader();
        } else {
          const payload = {
            tabella,
            codice: "",
            filtro: "",
            applicazione: "",
            attivi: "0",
          };
          const res = await generalResearch(payload as any, ac.signal);
          const raw = res?.data?.dati ?? res?.data ?? [];
          list = (Array.isArray(raw) ? raw : Object.values(raw)).map(
            mapApiItemToOption
          );
        }

        __optsCache.set(key, list);

        setOptions(
          initialOption
            ? [initialOption, ...list].filter(
                (o, i, a) => a.findIndex((x) => x.value === o.value) === i
              )
            : list
        );
        setLoadedOnce(true);
      } catch (e: any) {
        if (e?.name !== "CanceledError")
          console.error("options loader error:", e);
      } finally {
        setLoading(false);
      }
    }, [key, loadedOnce, customLoader, tabella, initialOption]);

    React.useEffect(() => () => abortRef.current?.abort(), []);

    return { options, loading, load };
  };

  type RHFResearchAutocompleteProps = {
    name: keyof FormValuesPacadc;
    label: string;
    tabella?: "ISTCOM" | "ESENZ" | "TIPRAM" | "TPRICE";
    initialCode?: string;
    initialLabel?: string;
    customLoader?: () => Promise<Option[]>;
    cacheKey?: string;
  };

  const RHFResearchAutocomplete = ({
    name,
    label,
    tabella = "ISTCOM",
    initialCode,
    initialLabel,
    customLoader,
    cacheKey,
  }: RHFResearchAutocompleteProps) => {
    const { control } = useFormContext<FormValuesPacadc>();

    const initialOption = React.useMemo(
      () =>
        initialCode
          ? {
              value: String(initialCode),
              label: initialLabel
                ? `${initialCode} - ${initialLabel}`
                : String(initialCode),
            }
          : undefined,
      [initialCode, initialLabel]
    );

    const { options, loading, load } = useResearchOptions(
      tabella,
      initialOption,
      customLoader,
      cacheKey
    );

    return (
      <Controller
        name={name}
        control={control}
        render={({ field }) => {
          const valueObj =
            options.find((o) => o.value === (field.value ?? "")) ?? null;
          return (
            <Autocomplete
              renderOption={(props, option) => (
                <li {...props} key={`opt_${(option as any).value}`}>
                  {(option as any).label}
                </li>
              )}
              options={options}
              value={valueObj}
              loading={loading}
              onOpen={load}
              onChange={(_, val) => field.onChange((val as any)?.value ?? "")}
              isOptionEqualToValue={(o, v) => o.value === v.value}
              getOptionLabel={(o) => (typeof o === "string" ? o : o.label)}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label={label}
                  size="small"
                  fullWidth
                  placeholder="Seleziona..."
                  InputProps={{
                    ...params.InputProps,
                    endAdornment: (
                      <>
                        {loading ? <CircularProgress size={18} /> : null}
                        {params.InputProps.endAdornment}
                      </>
                    ),
                  }}
                />
              )}
            />
          );
        }}
      />
    );
  };

  const dateRif = React.useCallback(
    () => dayjs(methods.getValues("dataVisita")).format("YYYY-MM-DD"),
    [methods]
  );

  // Ritorna il primo array trovato seguendo una lista di path noti,
  // altrimenti prova a prendere la prima proprietà che sia un array.
  const pickFirstArray = (obj: any, candidatePaths: string[]): any[] => {
    if (!obj || typeof obj !== "object") return [];
    for (const path of candidatePaths) {
      const arr = path.split(".").reduce<any>((acc, key) => acc?.[key], obj);
      if (Array.isArray(arr)) return arr;
    }
    const firstArr = Object.values(obj).find(Array.isArray);
    return Array.isArray(firstArr) ? (firstArr as any[]) : [];
  };

  // Prestazione SISS
  const loadRicAnapres = React.useCallback(async (): Promise<Option[]> => {
    const res = await ricAnapres({
      aziendaPrenotazione: azienda,
      dataRif: dateRif(),
      codSpecia: dataAppuntamento.CODSPECIA,
      codAnapre: dataAppuntamento.CODANAPRE,
      codAnapres: "",
      testValidita: "S",
      flDisattivati: "S",
    });
    const arr = res?.data?.dati ?? res?.data ?? [];
    return (Array.isArray(arr) ? arr : Object.values(arr)).map((r: any) => ({
      value: String(r.CODANAPRES ?? ""),
      label: r.DESANAPRES
        ? `${r.CODANAPRES} - ${r.DESANAPRES}`
        : String(r.CODANAPRES ?? ""),
    }));
  }, [azienda, dataAppuntamento, dateRif]);

  // Cod. Agenda
  const loadAnaggpPacada = React.useCallback(async (): Promise<Option[]> => {
    const res = await anaggpPacada({
      aziendaPrenotazione: azienda,
      dataRif: dateRif(),
      codSpecia: dataAppuntamento.CODSPECIA,
      codAnapre: dataAppuntamento.CODANAPRE,
      codAnapres:
        methods.getValues("prestazioneSISS") || dataAppuntamento.CODANAPRES,
      codMedint: methods.getValues("medico") || dataAppuntamento.CODMEDINT,
      codTpgpre: methods.getValues("tipologia") || dataAppuntamento.CODTPGPRE,
      codPgmedt: methods.getValues("programma") || dataAppuntamento.CODPGMEDT,
    });
    const arr = res?.data?.dati ?? res?.data ?? [];
    return (Array.isArray(arr) ? arr : Object.values(arr)).map((r: any) => ({
      value: String(r.CODANAGGP ?? ""),
      label: r.DESANAGGP
        ? `${r.CODANAGGP} - ${r.DESANAGGP}`
        : String(r.CODANAGGP ?? ""),
    }));
  }, [azienda, dataAppuntamento, methods, dateRif]);

  // Metodica (ricGPMetod)
  const loadRicGPMetod = React.useCallback(async (): Promise<Option[]> => {
    const res = await ricGPMetod({
      aziendaPrenotazione: azienda,
      dataRif: dateRif(),
      codAnapres:
        methods.getValues("prestazioneSISS") || dataAppuntamento.CODANAPRES,
    });

    const list = pickFirstArray(res?.data, ["dati.gpmetod", "gpmetod"]);

    return list.map((r: any) => {
      const code = String(r.CODGPMETOD ?? r.codGPMETOD ?? r.CODICE ?? "");
      const desc = r.DESGPMETOD ?? r.descrizione ?? "";
      return { value: code, label: desc ? `${code} - ${desc}` : code };
    });
  }, [azienda, dataAppuntamento, methods, dateRif]);

  //Diagnostica (ricGPQudia)
  const loadRicGPQudia = React.useCallback(async (): Promise<Option[]> => {
    const res = await ricGPQudia({
      aziendaPrenotazione: azienda,
      dataRif: dateRif(),
      codAgendaGP: methods.getValues("codAgenda") || dataAppuntamento.CODANAGGP,
      disciplinaQD: dataAppuntamento.DISCIPLINAANAGGP || "05",
    });

    // prova a estrarre l’array: può essere in data.dati.gpqudia oppure data.gpqudia
    const list = pickFirstArray(res?.data, ["dati.gpqudia", "gpqudia"]);

    return list.map((r: any) => {
      const code = String(r.CODGPQUDIA ?? r.codGPQUDIA ?? r.CODICE ?? "");
      const desc = r.DESGPQUDIA ?? r.descrizione ?? "";
      return { value: code, label: desc ? `${code} - ${desc}` : code };
    });
  }, [azienda, dataAppuntamento, methods, dateRif]);

  // Distretto (ricGPDistr)
  const loadRicGPDistr = React.useCallback(async (): Promise<Option[]> => {
    const res = await ricGPDistr({
      aziendaPrenotazione: azienda,
      dataRif: dateRif(),
      codAnapres:
        methods.getValues("prestazioneSISS") || dataAppuntamento.CODANAPRES,
    });

    // prende l’array in: data.dati.gpdistr oppure data.gpdistr
    const list = pickFirstArray(res?.data, ["dati.gpdistr", "gpdistr"]);

    return list.map((r: any, i: number) => {
      const code = String(r.CODGPDISTR ?? r.codGPDistr ?? r.CODICE ?? "");
      const desc = r.DESGPDISTR ?? r.descrizione ?? "";
      return { value: code, label: desc ? `${code} - ${desc}` : code };
    });
  }, [azienda, dataAppuntamento, methods, dateRif]);

  // Programma (ricpgmedt)
  const loadRicPgmedt = React.useCallback(async (): Promise<Option[]> => {
    const payload = {
      aziendaPrenotazione: azienda,
      codMedint: methods.getValues("medico") || dataAppuntamento.CODMEDINT,
      codSpecia: dataAppuntamento.CODSPECIA,
      codAnapre: dataAppuntamento.CODANAPRE,
      dataRif: dateRif(),
    };
    const res = await ricpgmedt(payload);
    console.log({ payload });

    const arr = res?.data?.dati?.programmi ?? res?.data?.programmi ?? [];
    return arr.map((r: any) => ({
      value: String(r.CODPGMEDT ?? ""),
      label: r.DESPGMEDT
        ? `${r.CODPGMEDT} - ${r.DESPGMEDT}`
        : String(r.CODPGMEDT ?? ""),
    }));
  }, [azienda, dataAppuntamento, methods, dateRif]);

  // funzione send del payload di eventuali modifiche apportate sul form
  const sendAppointmentDetailsUpdate = async () => {
    try {
      const payload: Pacadc = {
        idPacadc: dataAppuntamento.idPacadc,
        crud: "U",

        PACADCSWTEMP: dataAppuntamento.PACADCSWTEMP ? "D" : "T",
        PACADCSWPRIMARIO: "S",
        CODMEDINT: methods.getValues("medico") || "",
        DATAVISITA:
          dayjs(methods.getValues("dataVisita")).format("YYYY-MM-DD") ||
          "0001-01-01",
        ORAVISITA: dayjs(methods.getValues("oraVisita")).format("HHmm") || "0",
        DURATA: methods.getValues("durata") || "0",
        CODSPECIA: dataAppuntamento.CODSPECIA || "",
        CODANAPRE: dataAppuntamento.CODANAPRE || "",
        CODTPGPRE: methods.getValues("idTipoPrestazione") || "",
        CODIDTPRE: dataAppuntamento.CODIDTPRE,
        IMPEGNATIVA:
          methods.getValues("impegnativa") === ""
            ? ""
            : methods.getValues("impegnativa"),
        DATAIMPEGNATIVA:
          dayjs(dataAppuntamento.DATAIMPEGNATIVA).format("YYYY-MM-DD") ||
          "0001-01-01",
        DATA1DISP:
          dayjs(dataAppuntamento.DATA1DISP).format("YYYY-MM-DD") ||
          "0001-01-01",
        IUP: methods.getValues("iup") === "" ? "" : methods.getValues("iup"),
        CODESENZ: methods.getValues("esenzione") || "",
        COMPETENZA: methods.getValues("competenza") || "0",
        DIAGNOSI: methods.getValues("diagnosi") || "",
        NOTE: methods.getValues("notePrestazione") || "",
        SWFORZATURA: dataAppuntamento.SWFORZATURA ? "1" : "0",
        SWUSUFRUITO: methods.getValues("usufruito") ? "S" : "",
        SWARRIVATO: methods.getValues("arrivato") ? "S" : "",
        DATAARRIVO: fmtDate(methods.getValues("dataArrivo")),
        ORAARRIVO: fmtTime(methods.getValues("oraArrivo")),
        SWASSENZA: dataAppuntamento.SWASSENZA,
        MEDSOSTITUITO: dataAppuntamento.MEDSOSTITUITO,
        MEDRELAZIONATO: dataAppuntamento.MEDRELAZIONATO,
        IDACCETTAZIONE: dataAppuntamento.IDACCETTAZIONE,
        PRESCRSUGGERITA: dataAppuntamento.PRESCRSUGGERITA,
        FLAGALTRO: dataAppuntamento.FLAGALTRO,
        FLAGPIC: dataAppuntamento.FLAGPIC,
        IDPAI: dataAppuntamento.IDPAI,
        PROTOCOLLOPIC: dataAppuntamento.PROTOCOLLOPIC,
        TOLLGGATTESA: dataAppuntamento.TOLLGGATTESA,
        APPROFONDIMENTO: dataAppuntamento.APPROFONDIMENTO,
        PRIMOACCESSO: methods.getValues("primoAccesso") ? "1" : "0",
        IURP: methods.getValues("codiceIURP") || "",
        CODANAPRES: methods.getValues("prestazioneSISS") || "",
        IDAPPGP: methods.getValues("idAppuntamento") || "",
        CODANAGGP: methods.getValues("codAgenda") || "",
        IDPROGCOMBINATO: methods.getValues("idCombinato") || "",
        CODISTCOM: methods.getValues("idCombinata") || "",
        CODGPMETOD: methods.getValues("metodica") || "",
        CODGPQUDIA: methods.getValues("quadroDiagnostico") || "",
        CODGPDISTR: methods.getValues("distretto") || "",
        CODNOMENCLREG: methods.getValues("nomenclatoreReg") || "",
        CODCATALOGOPRESCR: methods.getValues("catalogoPrescr") || "",
        PRESCRITTORE: methods.getValues("prescrittore") || "",
        CODTPRICE: methods.getValues("tipoRicetta") || "",
        CODTIPRAM: methods.getValues("provenienza") || "",
        CODPGMEDT: methods.getValues("programma") || "",
        CODOPERATORE: dataAppuntamento.CODOPERATORE || "",
        CODCLSPRT: dataAppuntamento.CODCLSPRT ?? "",
        aziendaPrenotazione: azienda ?? "",
        CODOPEANNULLAMENTO:
          methods.getValues("codiceOperatoreAnnullamento") || "",
        DATAANNULLAMENTO:
          dayjs(methods.getValues("dataAnnullamento")).format("YYYY-MM-DD") ||
          "0001-01-01",
        IDOPANNULLAMENTO: methods.getValues("idOperatoreAnnullamento") || "",
        ORAANNULLAMENTO:
          dayjs(methods.getValues("oraAnnullamento")).format("HHmm") || "0",
        SWDAPAGARE: methods.getValues("daPagare") === true ? "S" : "",
        SWSOSPESO: methods.getValues("sospeso") === true ? "1" : "0",
      };

      const response = await datiPacadc(payload);
      console.log("Risposta dal server:", response);
      if (response.data.esito === "OK") {
        setSeverity("success");
        setMessage(response.data.messaggio);
      }
    } catch (err) {
      console.error("Errore fetch datiPacada:", err);
    }
  };

  return (
    // LocalizationProvider serve ai DatePicker per capire come leggere/scrivere le date nel formato richiesto
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <Helmet>
        <title>Dettaglio Appuntamento</title>
      </Helmet>
      <AllertMessage
        showAllert={showAllert}
        setShowAllert={setShowAllert}
        severity={severity}
        message={message}
        submitFunction={onAlertConfirm}
      />
      <FormProvider {...methods}>
        <Box sx={{ p: 2 }}>
          <Paper elevation={1} sx={{ p: 2.5, borderRadius: 2, mx: "auto" }}>
            <Tabs value={tab} onChange={(_, v) => setTab(v)} sx={{ mb: 2 }}>
              <Tab label="Dettaglio" />
              <Tab label="Dati annullamento" />
              <Tab label="Dati GP" />
            </Tabs>

            {/* FORM */}
            <Box component="form">
              {/* TAB 0: Dettaglio */}
              <TabPanel value={tab} index={0}>
                <Grid container spacing={2} alignItems={"center"}>
                  <Grid item xs={12} paddingBottom={1}>
                    <Typography
                      variant="h6"
                      fontSize={14}
                      fontFamily={"Rubik"}
                      color={"rgba(0, 0, 0, 0.60)"}
                      fontWeight={500}
                    >
                      Gestione data - orario appuntamenti annullati{" "}
                    </Typography>
                  </Grid>
                  {/* Prima riga */}
                  <Grid item xs={12} md={6}>
                    <RHFAutocomplete
                      name="medico"
                      label="Medico"
                      options={mediciOpts}
                    />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <RHFDate label="Data Visita" name="dataVisita" />
                  </Grid>

                  {/* Seconda riga */}
                  <Grid item xs={12} md={6}>
                    <RHFDate
                      name="primaDisponibilita"
                      label="Prima disponibilità"
                    />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <RHFTime label="Ora Visita" name="oraVisita" />
                  </Grid>

                  {/* Terza riga */}
                  <Grid item xs={12} md={6}>
                    <RHFText name="durata" label="Durata" />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <Stack
                      direction="row"
                      spacing={2}
                      useFlexGap
                      flexWrap="wrap"
                    >
                      <RHFCheck name="usufruito" label="Usufruito" />
                      <RHFCheck name="inArrivo" label="In Arrivo" />
                      <RHFCheck name="arrivato" label="Arrivato" />
                    </Stack>
                  </Grid>

                  {/* Quarta riga */}
                  <Grid item xs={12} md={6}>
                    <RHFDate label="Data Arrivo" name="dataArrivo" />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <RHFTime label="Ora Arrivo" name="oraArrivo" />
                  </Grid>

                  {/* Quinta riga */}
                  <Grid item xs={12} md={6}>
                    <RHFDate label="Competenza" name="competenza" />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <RHFText name="tipologia" label="Tipologia" />
                  </Grid>

                  {/* Sesta riga */}
                  <Grid item xs={12} md={6}>
                    <RHFText name="impegnativa" label="Impegnativa" />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <RHFText name="iup" label="IUP" />
                  </Grid>

                  {/* Settima riga */}
                  <Grid item xs={12} md={12}>
                    <Stack
                      direction="row"
                      spacing={2}
                      useFlexGap
                      flexWrap="wrap"
                      sx={{ height: "100%", alignItems: "center" }}
                    >
                      <RHFCheck name="primoAccesso" label="Primo accesso" />
                      <RHFCheck name="daPagare" label="Da Pagare" />
                    </Stack>
                  </Grid>

                  {/* Ottava Riga */}
                  <Grid item xs={12}>
                    <RHFText
                      name="diagnosi"
                      label="Diagnosi"
                      multiline
                      minRows={3}
                      helperText={
                        (methods.watch("diagnosi")?.length ?? 0) + "/400"
                      }
                    />
                  </Grid>

                  {/* Nona Riga */}
                  <Grid item xs={12}>
                    <RHFText
                      name="notePrestazione"
                      label="Note Prestazione"
                      multiline
                      minRows={3}
                      helperText={
                        (methods.watch("notePrestazione")?.length ?? 0) + "/400"
                      }
                    />
                  </Grid>
                </Grid>
              </TabPanel>
              {/* TAB 1: DATI Annullamento */}
              <TabPanel value={tab} index={1}>
                <Grid container spacing={2}>
                  <Grid item xs={12} paddingBottom={1}>
                    <Typography
                      variant="h6"
                      fontSize={14}
                      fontFamily={"Rubik"}
                      color={"rgba(0, 0, 0, 0.60)"}
                      fontWeight={500}
                    >
                      Gestione data - orario appuntamenti annullati{" "}
                    </Typography>
                  </Grid>
                  {/* Prima riga */}
                  <Grid item xs={12} md={6}>
                    <RHFDatePacadc
                      name="dataAnnullamento"
                      label="Data Annullamento"
                    />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <RHFTimePacadc
                      name="oraAnnullamento"
                      label="Ora Annullamento"
                    />
                  </Grid>
                  {/* Seconda riga */}
                  <Grid item xs={12} md={6}>
                    <RHFTextPacadc
                      name="codiceOperatoreAnnullamento"
                      label="Codice Operatore Annullamento"
                    />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <RHFCheck name="sospeso" label="Sospeso" />
                  </Grid>
                  {/* Terza riga */}
                  <Grid item xs={12} md={6}>
                    <RHFTextPacadc
                      name="idOperatoreAnnullamento"
                      label="ID operatore Annullamento"
                    />
                  </Grid>
                  <Grid item xs={0} md={6} />
                </Grid>
              </TabPanel>
              {/* TAB 2: DATI GP */}
              <TabPanel value={tab} index={2}>
                <Grid container spacing={2}>
                  <Grid item xs={12} paddingBottom={1}>
                    <Typography
                      variant="h6"
                      fontSize={14}
                      fontFamily={"Rubik"}
                      color={"rgba(0, 0, 0, 0.60)"}
                      fontWeight={500}
                    >
                      Gestione data - orario appuntamenti annullati{" "}
                    </Typography>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <RHFText name="idAppuntamento" label="ID appuntamento" />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <RHFText name="idCombinato" label="ID Combinato" />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <RHFText name="codiceIURP" label="Codice IURP" />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <RHFResearchAutocomplete
                      name="prestazioneSISS"
                      label="Prestazione SISS"
                      initialCode={String(dataAppuntamento.CODANAPRES || "")}
                      initialLabel={dataAppuntamento.DESANAPRES}
                      customLoader={loadRicAnapres}
                      cacheKey={`anapres|${azienda}|${
                        dataAppuntamento.CODSPECIA
                      }|${dataAppuntamento.CODANAPRE}|${dateRif()}`}
                    />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <RHFResearchAutocomplete
                      name="codAgenda"
                      label="Cod. agenda"
                      initialCode={String(dataAppuntamento.CODANAGGP || "")}
                      initialLabel={dataAppuntamento.DESANAGGP}
                      customLoader={loadAnaggpPacada}
                      cacheKey={`anaggp|${azienda}|${
                        dataAppuntamento.CODSPECIA
                      }|${dataAppuntamento.CODANAPRE}|${methods.getValues(
                        "prestazioneSISS"
                      )}|${methods.getValues("medico")}|${dateRif()}`}
                    />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <RHFResearchAutocomplete
                      name="idCombinata"
                      label="ID combinata"
                      tabella="ISTCOM"
                      initialCode={String(dataAppuntamento.CODISTCOM || "")}
                      initialLabel={dataAppuntamento.DESISTCOM}
                    />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <RHFResearchAutocomplete
                      name="quadroDiagnostico"
                      label="Quesito diagnostico"
                      initialCode={String(dataAppuntamento.CODGPQUDIA || "")}
                      initialLabel={dataAppuntamento.DESGPQUDIA}
                      customLoader={loadRicGPQudia}
                      cacheKey={`gpqudia|${azienda}|${methods.getValues(
                        "codAgenda"
                      )}|${dateRif()}`}
                    />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <RHFResearchAutocomplete
                      name="metodica"
                      label="Metodica"
                      initialCode={String(dataAppuntamento.CODGPMETOD || "")}
                      initialLabel={dataAppuntamento.DESGPMETOD}
                      customLoader={loadRicGPMetod}
                      cacheKey={`gpmetod|${azienda}|${
                        dataAppuntamento.CODSPECIA
                      }|${dataAppuntamento.CODANAPRE}|${methods.getValues(
                        "prestazioneSISS"
                      )}|${methods.getValues("programma")}|${dateRif()}`}
                    />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <RHFResearchAutocomplete
                      name="distretto"
                      label="Distretto"
                      initialCode={String(dataAppuntamento.CODGPDISTR || "")}
                      initialLabel={dataAppuntamento.DESGPDISTR}
                      customLoader={loadRicGPDistr}
                      cacheKey={`gpdistr|${azienda}|${
                        dataAppuntamento.CODSPECIA
                      }|${dataAppuntamento.CODANAPRE}|${methods.getValues(
                        "prestazioneSISS"
                      )}|${methods.getValues("programma")}|${methods.getValues(
                        "codAgenda"
                      )}|${dateRif()}`}
                    />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <RHFResearchAutocomplete
                      name="esenzione"
                      label="Esenzione"
                      tabella="ESENZ"
                      initialCode={String(dataAppuntamento.CODESENZ || "")}
                      initialLabel={dataAppuntamento.DESESENZ}
                    />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <RHFText name="prescrittore" label="Prescrittore" />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <RHFResearchAutocomplete
                      name="provenienza"
                      label="Provenienza"
                      tabella="TIPRAM"
                      initialCode={String(dataAppuntamento.CODTIPRAM || "")}
                      initialLabel={dataAppuntamento.DESTIPRAM}
                    />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <RHFResearchAutocomplete
                      name="tipoRicetta"
                      label="Tipo ricetta"
                      tabella="TPRICE"
                      initialCode={String(dataAppuntamento.CODTPRICE || "")}
                      initialLabel={dataAppuntamento.DESTPRICE}
                    />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <RHFResearchAutocomplete
                      name="programma"
                      label="Programma"
                      initialCode={String(dataAppuntamento.CODPGMEDT || "")}
                      initialLabel={dataAppuntamento.DESPGMEDT}
                      customLoader={loadRicPgmedt}
                      cacheKey={`pgmedt|${azienda}|${methods.getValues(
                        "medico"
                      )}|${dataAppuntamento.CODSPECIA}|${
                        dataAppuntamento.CODANAPRE
                      }|${dateRif()}`}
                    />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <RHFText name="nomenclatoreReg" label="Nomenclatore Reg." />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <RHFText name="catalogoPrescr" label="Catalogo prescr." />
                  </Grid>
                </Grid>
              </TabPanel>

              {/* Footer con i button di Conferma e Uscita */}
              <Grid container spacing={2} alignItems="center" mt={2}>
                <Grid item xs={12} md={6}>
                  <Button
                    variant="outlinedError"
                    color="error"
                    onClick={() => {
                      onClose();
                      prenotazioneRequest(
                        dataAppuntamento.NUMPRENOTAZIONE,
                        azienda ?? ""
                      );
                    }}
                  >
                    Uscita
                  </Button>
                </Grid>
                <Grid item xs={12} md={6}>
                  <Stack direction="row" spacing={1} justifyContent="flex-end">
                    <Button variant="outlined">Acc. Manuale</Button>
                    <Button variant="outlined">Log GP</Button>
                    <Button
                      type="submit"
                      variant="contained"
                      onClick={methods.handleSubmit(askConfirmEditAppuntamento)}
                    >
                      Conferma
                    </Button>
                  </Stack>
                </Grid>
              </Grid>
            </Box>
          </Paper>
        </Box>
      </FormProvider>
    </LocalizationProvider>
  );
}
